<script setup lang="ts">
import { checkout } from '@consumer/api'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { trackEvent } from '@shared/tracking'

const emit = defineEmits(['continueShopping'])

function goToCheckout () {
  trackEvent('click', 'cart-proceed-to-checkout')
  return checkout.checkout({ visit: true, method: 'GET' })
}

function continueShopping () {
  if (window.location.pathname === '/') {
    emit('continueShopping')
    return
  }
  window.location.href = '/'
}
</script>

<template>
  <GButton
    label="Keep Shopping"
    secondary
    name="add-to-cart-modal-keep-shopping"
    data-track-ga="cart-keep-shopping-button"
    @click="continueShopping"
  />
  <GPromiseButton
    label="Proceed to Checkout"
    name="add-to-cart-modal-proceed-to-checkout"
    primary
    :iconRight="faArrowRight"
    @click="goToCheckout"
  />
</template>
